<template>
  <div @click="selectArticle">
    <p>{{ title }}</p>
    <br />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    selected: Boolean,
    origin: {
      default: "createArticle",
      type: String,
    },
  },
  computed: {
    isFromCreateArticle() {
      return this.origin === "createArticle";
    },
    isFromSearchPopup() {
      return this.origin === "searchPopup";
    },
  },
  methods: {
    selectArticle() {
      this.$emit("selected_result");
    },
  },
};
</script>

<style scoped>
p {
  margin: 4%;
  text-align: center;
}
</style>
